import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["actionBar"]

  connect() {
    this.element.querySelectorAll(".commerce-native-stepper").forEach(stepper => this.refreshStepper(stepper))
    this.layoutChanged = () => {
      const overlap = Math.max(0, Number(window.StorefrontNativeLayout?.bottomOverlay) || 0)
      this.element.style.setProperty("--native-bottom-overlay", `${overlap}px`)
    }
    window.addEventListener("storefront:native-layout", this.layoutChanged)
    this.layoutChanged()
    this.actionBarObserver = new ResizeObserver(() => this.measureActionBar())
    this.actionBarTargets.forEach(bar => this.actionBarObserver.observe(bar))
    this.measureActionBar()
    this.viewportChanged = () => {
      const keyboardOpen = window.visualViewport && window.innerHeight - window.visualViewport.height > 120
      this.element.classList.toggle("commerce-keyboard-open", Boolean(keyboardOpen))
    }
    window.visualViewport?.addEventListener("resize", this.viewportChanged)
    this.viewportChanged()
  }

  disconnect() {
    window.visualViewport?.removeEventListener("resize", this.viewportChanged)
    window.removeEventListener("storefront:native-layout", this.layoutChanged)
    this.actionBarObserver?.disconnect()
  }

  actionBarTargetConnected(bar) {
    this.actionBarObserver?.observe(bar)
    this.measureActionBar()
  }

  actionBarTargetDisconnected(bar) {
    this.actionBarObserver?.unobserve(bar)
    this.measureActionBar()
  }

  measureActionBar() {
    const height = this.hasActionBarTarget ? this.actionBarTarget.getBoundingClientRect().height : 0
    this.element.style.setProperty("--native-action-height", `${height}px`)
  }

  togglePassword(event) {
    const button = event.currentTarget
    const input = button.closest(".commerce-password-field").querySelector("input")
    const reveal = input.type === "password"
    input.type = reveal ? "text" : "password"
    button.textContent = reveal ? "Hide" : "Show"
    button.setAttribute("aria-label", reveal ? "Hide password" : "Show password")
    button.setAttribute("aria-pressed", String(reveal))
  }

  step(event) {
    const stepper = event.currentTarget.closest(".commerce-native-stepper")
    const input = stepper.querySelector("input")
    if (input.disabled) return
    try {
      event.currentTarget.dataset.direction === "up" ? input.stepUp() : input.stepDown()
      input.dispatchEvent(new Event("input", { bubbles: true }))
    } catch { input.focus() }
  }

  quantityChanged(event) { this.refreshStepper(event.target.closest(".commerce-native-stepper")) }

  refreshStepper(stepper) {
    if (!stepper) return
    const input = stepper.querySelector("input")
    const value = input.valueAsNumber
    stepper.querySelector('[data-direction="down"]').disabled = input.disabled || (input.min !== "" && value <= Number(input.min))
    stepper.querySelector('[data-direction="up"]').disabled = input.disabled || (input.max !== "" && value >= Number(input.max))
  }
}
